import React, { Suspense } from "react";
import { Loader } from "@amzn/meridian";
import BotMessage from "src/components/shared/botMessage/botMessage";
import { useEffect, useState } from "react";
import AdminService from "../../service/adminService";
import { ConfirmationTurn } from "../../types";

// LazyChartBlock is dynamically loaded only when needed to improve initial load performance
const LazyChartBlock = React.lazy(() => import("./chartBlock"));

interface ChartLoaderProps {
  turn: ConfirmationTurn;
}

const ChartLoader = ({ turn }: ChartLoaderProps) => {
  const [chartJsonData, setChartJsonData] = useState<any | null>(null);
  const [csvData, setCsvData] = useState<{
    csvPreview: string;
    csvData: string;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const ShowLoader = () => {
    return (
      <BotMessage className="chat-messages__message">
        <Loader type="circular" size="medium" />
      </BotMessage>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Always fetch CSV data if showCsv is true
        if (turn.showCsv) {
          const csvDataResult = await AdminService.getCsvData(turn.chartId);
          setCsvData(csvDataResult);
        } else {
          const chartData = await AdminService.getChartDetails(turn.chartId);
          setChartJsonData(chartData);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [turn.chartId]);

  if (isLoading) {
    return <ShowLoader />;
  }

  return (
    <Suspense fallback={<ShowLoader />}>
      <LazyChartBlock
        chartJson={chartJsonData}
        turn={turn}
        csvPreview={csvData?.csvPreview}
        csvData={csvData?.csvData}
      />
    </Suspense>
  );
};

export default ChartLoader;
